import { getCompareValues } from "@nitro/gatsby-source-harvia-pim/helpers/attribute"
import { Product } from "@nitro/gatsby-source-harvia-pim/types/plugin"
import React from "react"
import Accordion from "../../molecules/Accordion"
import ProductDataTable from "./ProductDataTable"

type ProductComparisonAccordionProps = {
  products: Product[]
  keys: string[]
  title: string
}

const ProductComparisonAccordion = (props: ProductComparisonAccordionProps) => {
  const values = getCompareValues(props.products, props.keys)

  if (!values.length) return null

  return (
    <Accordion title={props.title}>
      <ProductDataTable products={props.products} values={values} />
    </Accordion>
  )
}
export default ProductComparisonAccordion
